import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import Modal from "react-bootstrap/Modal";
import {
  faFileDownload,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { ApplicationState } from "../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { hideChangePasswordModal } from "../../../../../../store/onboarding/cases/actions";
import { connect } from "react-redux";
import { changePassword } from "../../../../../../store/auth/actions";
import { toastr } from "react-redux-toastr";
import {
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Spinner,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import { validatePasswordWithDOM } from "../../../../../../utils/PasswordValidation";

library.add(faFileDownload, faPlusCircle);

type PropsFromState = {
  showModal: boolean;
  isLoading: {
    changePassword: boolean;
  };
  errors: {
    changePassword?: string;
  };
};

type DispatchProps = {
  hideChangePasswordModal: () => any;
  changePassword: (
    currentPassword: string,
    newPassword: string,
    newPasswordConfirm: string
  ) => any;
};

type Props = PropsFromState & DispatchProps;

type State = {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
  passwordsMatch: boolean;
  attributeCurrentType: string;
  attributeNewType: string;
  attributeConfirmType: string;
  isPasswordFieldsValid?: boolean;
};
class ChangePasswordModal extends Component<Props> {
  defState: Readonly<State> = {
    currentPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
    passwordsMatch: true,
    isPasswordFieldsValid: false,
    attributeCurrentType: "password",
    attributeNewType: "password",
    attributeConfirmType: "password",
  };

  state: Readonly<State> = this.defState;

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>
  ): void {
    if (
      prevProps.isLoading.changePassword &&
      !this.props.isLoading.changePassword
    ) {
      if (this.props.errors.changePassword) {
        let errorMessage = this.props.errors.changePassword;
        if (typeof this.props.errors.changePassword === "object" && this.props.errors.changePassword["non_field_errors"]) {
          errorMessage = this.props.errors.changePassword["non_field_errors"][0];
        }
        toastr.error("Alert", errorMessage);
      } else {
        this.props.hideChangePasswordModal();
      }
    }
  }

  onShowModal = () => {
    this.setState(this.defState);
  };

  handleChange = (event: React.FormEvent<any>) => {
    const { name, value } = event.currentTarget;

    this.setState({
        [name]: value,
      }, () => {
        const { newPassword, newPasswordConfirm } = this.state;

        const result = validatePasswordWithDOM(
          newPassword,
          newPasswordConfirm,
          "New Password and Confirm New Password fields do not match.",
          {
            newPasswordId: "new_password",
            newPasswordMsgId: "new_password_msg",
            confirmPasswordId: "confirm_new_password",
            confirmPasswordMsgId: "confirm_new_password_msg",
          }
        );

        this.setState({
          isPasswordFieldsValid: result.isPasswordFieldsValid,
          passwordsMatch: result.passwordsMatch,
        });
      }
    );
  };

  handleSavePassword = (event: React.FormEvent<any>) => {
    event.preventDefault();
    const { currentPassword, newPassword, newPasswordConfirm } = this.state;
    this.props.changePassword(
      currentPassword,
      newPassword,
      newPasswordConfirm
    );
  };

  currentPasswordShow = () => {
    this.setState({
      ...this.state,
      attributeCurrentType: this.state.attributeCurrentType === "password" ? "text": "password",
    })
  };

  newPasswordShow = () => {
    this.setState({
      ...this.state,
      attributeNewType: this.state.attributeNewType === "password" ? "text": "password",
    })
  };

  confirmPasswordShow = () => {
    this.setState({
      ...this.state,
      attributeConfirmType: this.state.attributeConfirmType === "password" ? "text": "password",
    })
  };

  render() {
    const { showModal } = this.props;
    const {
      currentPassword,
      newPassword,
      newPasswordConfirm,
      passwordsMatch,
      attributeCurrentType,
      attributeNewType,
      attributeConfirmType,
    } = this.state;
    return (
      <Modal
        show={showModal}
        onShow={this.onShowModal}
        onHide={this.props.hideChangePasswordModal}
        animation={false}
        backdropClassName={"customDarkModalBackdrop in"}
        backdrop={'static'}
        keyboard={false}
        centered
        
      >
        <Modal.Header
          closeButton
          className={"purpleModalHeader"}
        >
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <h3 className="font-weight-bold text-center mb-2">
            Please enter your current password and a new password.
          </h3> */}
          {/* <h4 className="text-center mb-3">
            Strong passwords should be 8+ characters with a mix of letters,
            numbers, and special characters.
          </h4> */}
          <Form onSubmit={this.handleSavePassword}>
            <FormGroup>
              <FormLabel column={false} className="font-weight-bold text-left">Current Password<span className="label-asterisk">*</span></FormLabel>
              <div className="input-container">
                <FormControl
                  required
                  autoFocus
                  type={attributeCurrentType}
                  placeholder="Enter current password"
                  aria-label="Current Password"
                  value={currentPassword}
                  name="currentPassword"
                  onChange={this.handleChange}
                />
                <FontAwesomeIcon  
                  onClick={this.currentPasswordShow}  
                  icon={attributeCurrentType == 'password' ? faEye : faEyeSlash} 
                  className="icon-eye"
                />
              </div>
            </FormGroup>
            <FormGroup>
              <FormLabel column={false} className="font-weight-bold text-left">New Password<span className="label-asterisk">*</span></FormLabel>
              <div className="input-container">
                <FormControl
                  required
                  type={attributeNewType}
                  placeholder="Enter new password"
                  aria-label="New Password"
                  value={newPassword}
                  name="newPassword"
                  onChange={this.handleChange}
                  minLength={8}
                  maxLength={20}
                  id={`new_password`}
                />
                <FontAwesomeIcon  
                    onClick={this.newPasswordShow}  
                    icon={attributeNewType == 'password' ? faEye : faEyeSlash} 
                    className="icon-eye"
                  />
              </div>
              <div id={`new_password_msg`} style={{color:"red"}}></div>
              <ul className="password-rules">
                <li>At least 8 to at most 20 characters long</li>
                <li>At least one uppercase letter (A-Z)</li>
                <li>At least one lowercase letter (a-z)</li>
                <li>At least one number (0-9)</li>
                <li>At least one non-alphanumeric character (! @ # $ % ^ & * ( ) _ + - = [ ] { } : ; ' " , . ? / ~ `)</li>
              </ul>
            </FormGroup>
            <FormGroup>
              <FormLabel column={false} className="font-weight-bold text-left">Confirm New Password<span className="label-asterisk">*</span></FormLabel>
              <div className="input-container">
                <FormControl
                  required
                  type={attributeConfirmType}
                  placeholder="Re-enter new password"
                  aria-label="Confirm New Password"
                  aria-describedby="basic-addon1"
                  value={newPasswordConfirm}
                  name="newPasswordConfirm"
                  onChange={this.handleChange}
                  isInvalid={!passwordsMatch}
                  minLength={8}
                  maxLength={20}
                  id={`confirm_new_password`}
                />
                <FontAwesomeIcon  
                  onClick={this.confirmPasswordShow}  
                  icon={attributeConfirmType == 'password' ? faEye : faEyeSlash} 
                  className="icon-eye"
                />
              </div>
              <div id={`confirm_new_password_msg`} style={{color:"red"}}></div>
              <Form.Control.Feedback type="invalid">
                Passwords do not match.
              </Form.Control.Feedback>
            </FormGroup>
            <div className="mt-4 pt-2"></div>
            <hr />
              <div className="btnActions">
              <button type="button" className="whiteBtnSm" onClick={this.props.hideChangePasswordModal}>
              <FormattedMessage id="app.forms.buttons.cancel" />
              </button>
              <button className="blueBtnSm" type="submit" 
                disabled={this.props.isLoading.changePassword ||!currentPassword ||!newPassword ||!newPasswordConfirm || !this.state.isPasswordFieldsValid}>
                <FormattedMessage id="app.forms.buttons.save" />
                {this.props.isLoading.changePassword && (
                  <Spinner animation="border" size="sm" />
                )}
              </button>
              </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ cases, auth }: ApplicationState): PropsFromState => {
  return {
    showModal: cases.modalsState.changePasswordModal,
    isLoading: {
      changePassword: auth.isLoading.changePassword,
    },
    errors: {
      changePassword: auth.errors.changePassword,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      hideChangePasswordModal: hideChangePasswordModal,
      changePassword: changePassword,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePasswordModal);
